import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SearchService } from '@core/services';
import {
  OiqFormDateComponent,
  OiqFormDropdownComponent,
  OiqFormInputComponent,
  OiqFormSearchComponent,
  OiqFormTextComponent,
  OiqFormTimeComponent,
} from '@oiq-ui-sdk/form';
import { OiqNotificationEntitySearchStore } from './notification-dialog.data';
import { OiqNotificationForm } from './notification.form';

@Component({
  selector: 'oiq-notification-form',
  templateUrl: './notification-form.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
  imports: [
    OiqFormInputComponent,
    OiqFormTextComponent,
    OiqFormDateComponent,
    OiqFormDropdownComponent,
    OiqFormTimeComponent,
    ReactiveFormsModule,
    OiqFormSearchComponent,
    RouterModule,
    AsyncPipe,
  ],
})
export class OiqNotificationFormComponent {
  public formatter = (x: { name: string }) => x.name;
  private _search = inject(SearchService);
  private _cdr = inject(ChangeDetectorRef);
  public entitySearchStore = new OiqNotificationEntitySearchStore(this._search);
  public form = new OiqNotificationForm(this._search);

  constructor() {
    this.form.cdr = this._cdr;
    this.form.entityType$.subscribe(_entityType => {
      this.entitySearchStore.entityData = null;
      this.entitySearchStore.type = _entityType;

      if (this.form.get('entityType').dirty) {
        this.form.get('entityId').setValue(null);
        this.form.get('entityName').setValue(null);
        console.log('entityType$.subscribe', _entityType);
      }
    });
  }

  handleSearchEvent(event) {
    console.log('handleSearchEvent', event);
    switch (event.type) {
      case 'select':
        this.form.selectEntity(event.data.data);
        break;
      case 'clear':
        this.form.selectEntity(null);
        break;
      default:
        break;
    }
  }
}
